﻿
(() => {
    angular.module('fliptoWeb')
        .constant('callTimes', {  
        list: [
            { id: 0, description: "Any business hour", name: "Any business hour" },
            { id: 1, description: "Early morning (8-10am)", name: "Early morning" },
            { id: 2, description: "Late morning (10am-Noon)", name: "Late morning" },
            { id: 3, description: "Mid-day (Noon-1pm)", name: "Mid-day" },
            { id: 4, description: "Early afternon (1-3pm)", name: "Early afternoon" },
            { id: 5, description: "Late afternoon (3-5pm)", name: "Late afternoon" },
            { id: 6, description: "Evening (5-8pm)", name: "Evening" }
        ]
    }) 
})()



